import { cultures } from '../constants/cultures';
import { getDefaultDisclaimer } from '../helpers/defaultBlogDisclaimer';
export class FormHelper {
	static formikProps(props) {
		return {
			enableReinitialize: true,
			validateOnMount: true,
			validateOnChange: false,
			...props,
		};
	}

	static buildAddressFormGroup(
		isDisabled = true,
		countryValue = null,
		values = null
	) {
		return {
			addressLine: values?.addressLine || '',
			additionalAddressLine: values?.additionalAddressLine || '',
			city: values?.city || '',
			postalCode: values?.postalCode || '',
			countryId: values?.country?.id || '',
		};
	}

	static buildOtherFormGroup(isDisabled = true, values) {
		return {
			valueId: values?.value?.id || '',
			valueSpecified: values?.valueSpecified || '',
		};
	}

	static getComplexOther(formGroupValue) {
		return {
			valueId: formGroupValue?.value?.id,
			valueSpecified: formGroupValue?.valueSpecified,
		};
	}
	static getTaxResidencies(taxResidency = [], type = 1) {
		if (taxResidency && taxResidency?.length) {
			return taxResidency;
		}
		return [{ taxId: '', countryId: null, hasTaxId: null, whyNotId: null, type: type }];

	}

	static isValidPhone(phone) {
		if (phone && phone?.code && phone?.number) {
			return true;
		}
		return false;
	}

	static buildRiskFactorsFormGroup(values) {
		return {
			agreement: values?.agreement || null,
			riskRating: values?.riskRating || '',
			rationale: values?.rationale || '',
		};
	}

	static createLanguageFormArray({
		withTitle = true,
		withDescription = true,
		withJoinDescription = false,
		fullname = false,
		isFAQ = false,
		addPoster = false,
		withFullName = false,
		withMetaDescription = false,
		showAltText = false,
		showBlogStickyBannerInfo = false,
		withDisclaimer = false,
		withOverview = false,
		withIsInvestors = false,
		withBorrowers = false,
		withSubTitle = false,
		withFeatureComparison = false,
		additionalFields = null,
		withSchema = false

	}) {
		const formGroups = [];
		for (const key in cultures) {
			const culture = cultures[key];
			let cultureFormGroup = {
				culture: culture,
			};
			if (withTitle) {
				cultureFormGroup = {
					...cultureFormGroup,
					[!isFAQ ? 'title' : 'question']: '',
				};
			}
			if (withDescription) {
				cultureFormGroup = {
					...cultureFormGroup,
					[!isFAQ ? 'description' : 'answer']: '',
				};
			}
			if (withMetaDescription) {
				cultureFormGroup = {
					...cultureFormGroup,
					metaDescription: '',
					metaTitle: '',
				};
			}
			if (withSchema) {
				cultureFormGroup = {
					...cultureFormGroup,
					schema: '',
				};
			}
			if (withDisclaimer) {
				cultureFormGroup = {
					...cultureFormGroup,
					disclaimer: getDefaultDisclaimer()[key],
				};
			}
			if (withJoinDescription) {
				cultureFormGroup = {
					...cultureFormGroup,
					joinDescription: '',
				};
			}

			if (fullname) {
				cultureFormGroup = {
					...cultureFormGroup,
					fullname: '',
				};
			}

			if (withFeatureComparison) {
				cultureFormGroup = {
					...cultureFormGroup,
					featureComparison: '',
				};
			}

			if (withOverview) {
				cultureFormGroup = {
					...cultureFormGroup,
					overview: '',
				};
			}

			if (withSubTitle) {
				cultureFormGroup = {
					...cultureFormGroup,
					subTitle: '',
				};
			}

			if (withIsInvestors) {
				cultureFormGroup = {
					...cultureFormGroup,
					forInvestors: '',
				};
			}

			if (withBorrowers) {
				cultureFormGroup = {
					...cultureFormGroup,
					forBorrowers: '',
				};
			}

			if (withFullName) {
				cultureFormGroup = {
					...cultureFormGroup,
					fullName: '',
				};
			}

			if (addPoster) {
				cultureFormGroup = {
					...cultureFormGroup,
					imageUrl: '',
					file: '',
				};
			}

			if (showAltText) {
				cultureFormGroup = {
					...cultureFormGroup,
					altTagText: '',
				};
			}
			if (showBlogStickyBannerInfo) {
				cultureFormGroup = {
					...cultureFormGroup,
					ctaText: '',
					ctaUrl: '',
					ctaButtonText: '',
				};
			}
			if (additionalFields) {
				cultureFormGroup = {
					...cultureFormGroup,
					...additionalFields,
				};
			}

			formGroups.push(cultureFormGroup);
		}
		return formGroups;
	}

	static createAnnouncementLanguageFormArray() {
		const formGroups = [];
		for (const key in cultures) {
			const culture = cultures[key];
			let cultureFormGroup = {
				culture: culture,
				title: '',
				text: '',
				buttonName: '',
				linkTranslation: '',
			};
			formGroups.push(cultureFormGroup);
		}
		return formGroups;
	}

	static validateForm(form) {
		form.submitForm();
	}
}
